import { Component, Prop, Vue } from 'vue-property-decorator';
import { CreateElement, VNode } from 'vue';
import './style.styl';

@Component({
  name: 'SimpleDescription',
})
export default class SimpleDescription extends Vue {
  @Prop({type: String, default: ''}) public readonly title!: string;
  @Prop({type: String, default: ''}) public readonly subTitle!: string;
  @Prop({type: String, default: ''}) public readonly description!: string;

  private render(createElement: CreateElement): VNode {
    return createElement('div', {
      class: 'flex-column',
    }, [
      !!this.title && createElement('h6', this.title),
      !!this.subTitle && createElement('p', { class: 'p5'}, this.subTitle),
      !!this.description && createElement('p', {
        domProps: {
          innerHTML: this.description,
        },
        class: 'simple-description',
      }),
      this.$slots.default,
    ]);
  }
}
